import { Property } from "../../../global/types";
import { filterPropertiesByBounds, MapBounds } from "./mapBoundsUtils";
import {
  ListPropertyResolution,
  resolveListProperties,
} from "./listPropertyResolver";

export interface MapNavigatedResolution<T> extends ListPropertyResolution<T> {
  isViewportFiltered: boolean;
}

export interface ResolveMapNavigatedOptions {
  neighborhood: string | null | undefined;
  mapBounds: MapBounds | null;
  useViewportFilter: boolean;
}

/**
 * Resolves which properties to show after map navigation.
 * Viewport bounds take priority once the user has moved/zoomed the map;
 * otherwise neighborhood URL filtering (search bar / deep link) applies.
 */
export function resolveMapNavigatedProperties<T extends Property>(
  allProperties: T[],
  options: ResolveMapNavigatedOptions
): MapNavigatedResolution<T> {
  if (options.useViewportFilter && options.mapBounds) {
    return {
      properties: filterPropertiesByBounds(
        allProperties,
        options.mapBounds
      ) as T[],
      appliedNeighborhood: null,
      fellBackToCity: false,
      isViewportFiltered: true,
    };
  }

  const neighborhoodResolution = resolveListProperties(
    allProperties,
    options.neighborhood
  );

  return {
    ...neighborhoodResolution,
    isViewportFiltered: false,
  };
}
